import { useMutation, useQueryClient } from 'react-query';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { postV2ApiCompanyIdTravelTripsTripIdPayments } from 'src/client/spendesk-api';

export const usePayTripBookings = () => {
  const companyId = useCompanyId();
  const queryClient = useQueryClient();

  return useMutation(
    ['payTripBookings', companyId],
    async (tripId: string) => {
      const response = await postV2ApiCompanyIdTravelTripsTripIdPayments({
        path: {
          companyId,
          tripId,
        },
      });

      if (response.statusCode !== 200) {
        throw new Error('Failed to initiate payment for trip bookings');
      }

      return response.body;
    },
    {
      retry: false,
      onSuccess: (_, tripId) => {
        queryClient.invalidateQueries(['trip', tripId]);
        queryClient.invalidateQueries(['bookingDetails', tripId]);
      },
    },
  );
};
